import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, AdminNavEntryPoint, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { eversightRouter } from './routing/eversightRouter'
import { eversightAdminRouter } from './routing/eversightAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { eversightCompetitiveIntelAccessControl } from './access-control/eversightCompetitiveIntelAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'eversight',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'eversight-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [eversightRouter],
    admin: [eversightAdminRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.AnalyticsMerchandising,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View competitive intelligence and market pricing data',
          labelId: 'eversightDomain.competitiveIntel',
          href: 'https://price.eversightlabs.com/',
          position: 99, //last
          accessControl: eversightCompetitiveIntelAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
